import React, { useState } from "react";
import { Button } from "@mui/material";
import ModalResetPassword from "../modal/ModalResetPassword";
import { useSelector } from "react-redux";

interface IResetPassword {
  email: string;
}

function ResetPassword({ email }: IResetPassword) {
  const { profile } = useSelector((state: any) => state.auth);
  const [openModal, setOpenModal] = useState<boolean>(false);

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  if (!profile?.admin_app || email === profile?.email) {
    return null;
  }

  return (
    <>
      {openModal && (
        <ModalResetPassword
          email={email}
          title={`Đổi mật khẩu người dùng '${email}'`}
          open={openModal}
          onClose={handleCloseModal}
        />
      )}
      <Button
        onClick={() => setOpenModal(true)}
        variant="outlined"
        size="small"
        sx={{ textTransform: "none" }}
      >
        Reset mật khẩu
      </Button>
    </>
  );
}

export default ResetPassword;
